import { React, useState, useEffect } from 'react';
import AddNewTag from './AddNewTag';
import { UI_LABELS } from '../constants/constants';
import { CiSquarePlus } from "react-icons/ci";
import { CiSquareMinus } from "react-icons/ci";
import { IoClose } from 'react-icons/io5';
import '../components/Filters/Filters.scss'

const Tags = ({
  tags,
  handleSelected,
  activeTags,
  className,
  group,
  showTagAdd,
  setShowTagAdd,
  customAddComponent,
}) => {
  const [internalShowTagAdd, setInternalShowTagAdd] = useState(false);
  const [list, setList] = useState([]);

  // Use external showTagAdd if provided, otherwise use internal state
  const isShowTagAdd =
    showTagAdd !== undefined ? showTagAdd : internalShowTagAdd;
  const toggleShowTagAdd = setShowTagAdd || setInternalShowTagAdd;

  useEffect(() => {
    setList(tags);
  }, [tags]);

  //Toggle
  const toggleTagAdd = () => {
    toggleShowTagAdd((prev) => !prev);
  };

  const handleTagUpdate = (action, value) => {
    if (action === 'add') {
      setList([...list, ...value]);
    } else if (action === 'remove') {
      setList(list.filter((t) => t !== value[0]));
    }
  };

  return (
    <>
      <div className={`tags ${className}`}>
        <div className="filter-chips-container">
          {list && list.length ? (
            list.map((tag, i) => (
              <div
                className={`filter-chip ${
                  activeTags &&
                  activeTags.length &&
                  activeTags.indexOf(tag) > -1 &&
                  'active'
                }`}
                key={`tag-${i}`}
              >
                <span className="filter-chip-text">
                  {tag}
                </span>
                <button
                  type="button"
                  className="filter-chip-clear"
                  onClick={() => {
                    handleSelected(tag);
                  }}
                  aria-label={`Remove ${tag} tag`}
                >
                  <IoClose size={14} />
                </button>
              </div>
            ))
          ) : (
            <div className="alert-no-tags">
              Add some {`${UI_LABELS[group] ? UI_LABELS[group] : 'tags'}`} to your profile!{' '}
              <span style={{ fontSize: '1.5em' }}>👉🏻</span>
            </div>
          )}
          <div onClick={toggleTagAdd} style={{ cursor: 'pointer' }}>
            {isShowTagAdd ? <CiSquareMinus style={{fontSize: '32px' }} /> : <CiSquarePlus style={{fontSize: '32px' }} />}
          </div>
        </div>
      </div>
      <div className='add-new-tag'>
        {isShowTagAdd &&
          (customAddComponent || (
            <AddNewTag
              handleTagUpdate={handleTagUpdate}
              listTags={list}
              group={group}
            />
          ))}
      </div>
    </>
  );
};
export default Tags;